module.exports = __webpack_public_path__ + "static/fonts/OpenSans300italic.454f5707.ttf";